import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers} from "@angular/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { environment } from "./environment";

@Injectable()
export class InterceptedHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
    }

    // Grant a client access to the API using an environment key
    request(url: string, body: string, reqoptions?: RequestOptionsArgs): Observable<Response> {
        return super.get( url, this.updateHeaders(reqoptions) );
    }

    get(url: string, body: string, reqoptions?: RequestOptionsArgs): Observable<Response> {
        return super.get( url, this.updateHeaders(reqoptions) );
    }

    post(url: string, body: string, reqoptions?: RequestOptionsArgs): Observable<Response> {
        return super.post( url, body, this.updateHeaders(reqoptions) );
    }

    put(url: string, body: string, reqoptions?: RequestOptionsArgs): Observable<Response> {
        return super.put( url, body, this.updateHeaders(reqoptions) );
    }

    delete(url: string, reqoptions?: RequestOptionsArgs): Observable<Response> {
        return super.delete( url, this.updateHeaders(reqoptions) );
    }


    private updateHeaders(reqoptions) {
        var headers = reqoptions.headers.append('Asylum', environment.apiKey);
        let relationship = new RequestOptions({ headers: headers });

        return relationship;
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs) : RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        options.headers.append('Content-Type', 'application/json');

        return options;
    }
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/app.interceptor.ts